import React from "react";
import {Button, Modal, ModalBody, ModalFooter} from "react-bootstrap";
import "../../style/modal/_process_confirm_modal.scss";

interface ProcessConfirmModalProps{
    title?: string;
    message: string;
    show: boolean;
    handleNo: () => void;
    handleYes: () => void;
    checkboxLabel?: string;
    checkboxChecked?: boolean;
    onCheckboxChange?: (checked: boolean) => void;
}

const ProcessConfirmModal:React.FC<ProcessConfirmModalProps> = (
    {
        title= "処理確認",
        message= "",
        show = false,
        handleNo = () => {},
        handleYes = () => {},
        checkboxLabel,
        checkboxChecked = false,
        onCheckboxChange = () => {}
    }
) => {
  return (
      <Modal className="process-confirm-modal" show={show} centered>
          <ModalBody>
              <h2>{title}</h2>
              <p>
                  {message.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                          {line}
                          {i < message.split('\n').length - 1 && <br />}
                      </React.Fragment>
                  ))}
              </p>
              {checkboxLabel && (
                  <label className="confirm-checkbox">
                      <input
                          type="checkbox"
                          checked={checkboxChecked}
                          onChange={(e) => onCheckboxChange(e.target.checked)}
                      />
                      {checkboxLabel}
                  </label>
              )}
          </ModalBody>
          <ModalFooter>
              <Button variant="secondary" onClick={handleNo}>いいえ</Button>
              <Button variant="primary" onClick={handleYes}>はい</Button>
          </ModalFooter>
      </Modal>
  );
};
export default ProcessConfirmModal;
